export default __webpack_public_path__ + "static/media/kenya.cf3b718c.svg";